import React from "react";
import styled from "styled-components";

export const dropdownIcon: React.CSSProperties = {
	padding: "15px",
	cursor: "pointer",
	color: "#fff",
};

export const overlayTitle: React.CSSProperties = {
	backgroundColor: "#f8f8f8",
	padding: "12px 116px 12px 8px",
	fontSize: "20px",
	fontWeight: "500",
	lineHeight: 1.4,
	letterSpacing: "normal",
	textAlign: "left",
};

export const menuItems: React.CSSProperties = {
	padding: "12px 0px 12px 8px",
	color: "#2e333e",
	fontSize: "16px",
	display: "flex",
	width: "100%",
	position: "relative",
};

export const menuItemsChangeAccount: React.CSSProperties = {
	padding: "12px 0px 12px 8px",
	color: "#2e333e",
	fontSize: "16px",
	display: "none",
	width: "100%",
	position: "relative",
};

export const menuItemText: React.CSSProperties = {
	padding: "13px 0 15px 17px",
	width: "92px",
	height: "20px",
};

export const menuItemIcon: React.CSSProperties = {
	backgroundColor: "#171717",
	padding: "9px 9px 8.3px 8px",
	borderRadius: "5px",
	width: "41px",
	height: "41px",
};

export const DropdownCloseCircle = styled.svg<{ $background?: string }>`
	background: ${(props) =>
		props.$background ? `url(${props.$background})` : "none"};
	height: 24px;
	width: 24px;
	stroke: transparent;
	stroke-width: 0px;
	z-index: 99;

	&:hover {
		opacity: 0.9;
	}
`;


export const StyledImage = styled.img<{ $backgroundImage?: string | null }>`
	background: ${(props) =>
		props.$backgroundImage ? `url(${props.$backgroundImage}) center/cover` : "none"};
	height: 50px;
	width: 50px;
	border-radius: 50%;
	object-fit: cover;
	display: block;
`;
